import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import getInitials from '../../helpers/utils';
import { DownloadDocNotificationIcon } from '../icons/icons';
import Tooltip from '../tooltip/tooltip';
import UserImage from '../user-image/user-image';
import DynamicTooltip from '../tooltip/dynamic-tooltip';

function DocumentItem({ data, t }) {
  const hostUrl = `${window.location.protocol}//${window.location.host}`;
  const [toggleShowMore, setToggleShowMore] = useState(false);
  const [dataLength, setDataLength] = useState(0);
  const contentRef = useRef(null);
  const contentContainer = useRef(null);
  const [contentContainerHeight, setContentContainerHeight] = useState(0);
  const [currentID, setCurrentID] = useState(false);

  const toggleSelf = (e) => {
    setCurrentID(e.target.id);
  };

  const toggleShow = () => {
    setToggleShowMore(!toggleShowMore);
  };

  const rmNameText = (txt, mediaArr) => {
    let rmText = '';
    if (mediaArr.length === 1) {
      rmText = `${txt.replace(
        mediaArr[0].originalFilename,
        `<a href=${mediaArr?.[0]?.path} class="link">
            <Tooltip content=${mediaArr[0].originalFilename} direction="bottom">
            ${
              mediaArr[0]?.originalFilename?.length > 15
                ? `${mediaArr[0]?.originalFilename?.slice(0, 15)}...`
                : mediaArr[0]?.originalFilename
            }
            </Tooltip>
          </a>
        `
      )}`;
    } else {
      rmText = txt;
    }
    return rmText;
  };

  useEffect(() => {
    setDataLength(contentRef?.current?.getBoundingClientRect()?.height);
  }, [dataLength]);
  useEffect(() => {
    setContentContainerHeight(
      contentContainer?.current?.getBoundingClientRect()?.height
    );
  }, [contentContainerHeight]);

  return (
    <li
      className={`${currentID === data?._id ? 'active' : ''}${
        !data?.isRead ? ' unread' : ''
      }`}
      role="presentation"
      onClick={toggleSelf}
      id={data._id}
      onKeyUp={toggleSelf}
    >
      <div className="notification-item ">
        <span className="time">{data?.diff}</span>
        <div className="user-image">
          <UserImage
            path={data?.senderOrgLogo}
            shortName={getInitials(data?.senderOrgName)}
          />
          {/* {data?.senderOrgLogo !== '' ? (
            <img src={data?.senderOrgLogo} alt={data?.senderOrgName} />
          ) : (
            <span className="image">{getInitials(data?.senderOrgName)}</span>
          )} */}
        </div>
        <div className="details actionable">
          <p>
            <span class="name">{data?.senderOrgName}</span>
          </p>
          <div
            className={`position-relative content ${
              toggleShowMore ? 'visible-all' : ''
            }`}
            ref={contentContainer}
          >
            <p
              ref={contentRef}
              className="position-absolute opacity-0 disable-pointer"
            >
              {ReactHtmlParser(
                rmNameText(data?.text, data?.notificationData?.media)
              )}{' '}
              {t('notifications.in')}{' '}
              <span className="text-capitalize">
                {t(`notifications.${data?.type}`)}
              </span>
              <a
                className="link disable-pointer"
                href={`${hostUrl}/${data.link}`}
              >
                <DynamicTooltip
                  content={`#${data?.relationNo || ''}`}
                  className="tooltip-maxcontent"
                  wrapperClass="enable-pointer"
                >
                  #{data?.relationNo && data?.relationNo}
                </DynamicTooltip>
              </a>
              &nbsp;
              {t('notifications.By')}{' '}
              <span className="name"> {data?.senderName}</span>{' '}
              {/* <a href={data?.notificationData?.media?.[0]?.path} className="link">
              {data?.notificationData?.media?.[0]?.originalFilename}
            </a> */}
            </p>
            <p>
              {ReactHtmlParser(
                rmNameText(data?.text, data?.notificationData?.media)
              )}{' '}
              {t('notifications.in')}{' '}
              <span className="text-capitalize">
                {t(`notifications.${data?.type}`)}
              </span>
              <a
                className="link"
                href={`${hostUrl}/${data.link}?notificationId=${data?.notificationId}`}
              >
                <DynamicTooltip
                  content={`#${data?.relationNo || ''}`}
                  className="tooltip-maxcontent"
                  wrapperClass="enable-pointer"
                >
                  #{data?.relationNo && data?.relationNo}
                </DynamicTooltip>
              </a>
              <span> {t('notifications.By')} </span>
              <span className="name"> {data?.senderName}</span>{' '}
              {/* <a href={data?.notificationData?.media?.[0]?.path} className="link">
              {data?.notificationData?.media?.[0]?.originalFilename}
            </a> */}
            </p>
          </div>
          {dataLength > contentContainerHeight ? (
            <button type="button" className="show-more" onClick={toggleShow}>
              {toggleShowMore
                ? t('notifications.showLess')
                : t('notifications.showMore')}
            </button>
          ) : (
            ''
          )}
        </div>
        <div className="action">
          {data?.notificationData?.media?.map((value) => {
            return (
              <a href={value?.path}>
                <Tooltip
                  content={t('notifications.downloadTooltip')}
                  direction="bottom"
                >
                  <DownloadDocNotificationIcon />
                </Tooltip>
              </a>
            );
          })}
        </div>
      </div>
    </li>
  );
}

export default DocumentItem;
DocumentItem.propTypes = {
  data: PropTypes.arrayOf(Object),
  t: PropTypes.func,
};
DocumentItem.defaultProps = {
  data: {},
  t: () => {},
};
